const format_array = (name: string, array: any[]) => `${ name }=` + array.map(encodeURIComponent).join(`&${ name }=`)

type EncodableType = string | number | boolean | { toString(): string }
type AcceptableInputValue = EncodableType | EncodableType[] | undefined

/*
Differences from `new URLSearchParams(object)`:
- arrays are serialized in the way expected by polkadot / https://nodejs.org/api/querystring.html#querystringparsestr-sep-eq-options
- `undefined` values are ignored
- a question mark prefix is added if there is a querystring
*/
export default (object: { [key: string]: AcceptableInputValue }) => {
	const properties = Object.entries(object).filter(
		([ , value ]) => value !== undefined && !(Array.isArray(value) && value.length === 0)
	).map(
		([ key, value ]) => Array.isArray(value)
			? format_array(key, value)
			: key + `=`
				// @ts-expect-error the default TS type for encodeURIComponent is incorrect, an object with a toString method is fine
				+ encodeURIComponent(value)
	)

	return properties.length === 0
		? ``
		: `?` + properties.join(`&`)
}
